import { useEffect, useState } from 'react';

const KEY = 'wo-instance';

function remembered(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/**
 * Orange "DEV / TEST SYSTEM" banner on every screen (office, sign-in and mechanic) when the
 * server's /health says instance = dev. The answer is remembered so an offline iPad still shows it.
 */
export function DevBanner() {
  const [instance, setInstance] = useState<string | null>(remembered);

  useEffect(() => {
    let alive = true;
    // /health answers 503 (with the same body) when the database is down; read it either way.
    fetch('/health', { cache: 'no-store' })
      .then((r) => r.json() as Promise<{ instance?: string }>)
      .then((b) => {
        if (!alive) return;
        const value = b.instance ?? 'prod';
        setInstance(value);
        try {
          localStorage.setItem(KEY, value);
        } catch {
          /* private mode: fine */
        }
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  if (instance !== 'dev') return null;
  return (
    <>
      {/* Always-visible stripe, above modals and sticky headers */}
      <div aria-hidden className="pointer-events-none fixed inset-x-0 top-0 z-[100] h-1.5 bg-orange-500" />
      <div role="status" className="bg-orange-500 px-4 py-2 text-center text-base font-bold tracking-wide text-white">
        DEV / TEST SYSTEM: not the real work orders. Emails go only to the admin.
      </div>
    </>
  );
}
